// removed by extract-text-webpack-plugin
module.exports = {"SingleView":"SingleView__SingleView__F7lBz","SingleElement":"SingleView__SingleElement__39KQJ","Image":"SingleView__Image__2HZKr","Caption":"SingleView__Caption__2W9DR","User":"SingleView__User__2B5Wa","UserInterest":"SingleView__UserInterest__5kdKP","Image2":"SingleView__Image2__3Tohg","Likes":"SingleView__Likes__1GMaW","Comment":"SingleView__Comment__21VFx","SingleComment":"SingleView__SingleComment__3aZ_O","RemoveComment":"SingleView__RemoveComment__1UAOX","CommentText":"SingleView__CommentText__2ha5S"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SingleView/SingleView.css
// module id = 112
// module chunks = 0